<template>
    <v-card class="d-flex flex-column justify-space-between" width="350" height="110"  style="position: relative">



        <v-skeleton-loader v-if="loading" type="card" style="position: absolute; width: 100%; height: 100%"/>
        <div class="px-3 pt-2 text-start body-1 font-weight-thin ">
            Unproductive Time
        </div>
        <div class="px-4 pb-2 caption grey--text ">
            Total unproductive time for today
        </div>
        <div class="flex-grow-1"></div>
        <template v-if="!loading">
            <sub style="line-height: 1; position: absolute; bottom: 0; right: 0" class="grey--text pa-1">(Last 7 days)</sub>
            <v-scroll-x-transition>
                <div class="px-3 pb-1 text-h4 font-weight-light d-flex align-center" v-if="!loading">
                    <v-icon large left>mdi-timer-outline</v-icon>{{ hourDisplayWithoutUnit(stats[stats.length - 1].value) }}
                </div>
            </v-scroll-x-transition>
            <div style="width: 60%; position: absolute; right: 0; bottom: 8px" v-if="!loading" class="pa-2">
                <v-sparkline
                        :height="75"
                        :value="series"
                        :gradient="gradient"
                        :smooth="10"
                        :padding="4"
                        :line-width="5"
                        stroke-linecap="round"
                        gradient-direction="top"
                        :fill="false"
                        type="trend"
                        :auto-line-width="false"
                        auto-draw
                ></v-sparkline>
            </div>
        </template>
    </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {hourDisplayWithoutUnit, minuteDisplayWithoutUnit} from "@/core/codeFunctions";
export default {
    components: {
        apexChart: VueApexCharts,
    },
    props: {
        propName: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading: true,
            stats: [],
            gradient: ["var(--v-error-darken1)", "var(--v-error-darken2)"],
            refreshInterval: null,
            hourDisplayWithoutUnit,
        }
    },
    mounted() {
        this.loadProductivity();
        this.refreshInterval = setInterval(() => {
            this.loadProductivity()
        }, 60000)
    },
    beforeDestroy() {
        clearInterval(this.refreshInterval)
    },
    methods: {
        async loadProductivity() {
            try {
                this.stats = await this.$newReq('GET', 'dashboard/stats/totalUnproductive')
                this.loading = false
            } catch (e) {
                console.log(e)
            }
        }
    },
    computed: {
        labels() {return this.stats.map(stat => stat.key)},
        series() {return this.stats.map(stat => stat.value)},
    }
}
</script>

<style scoped>

</style>